import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAttachmentByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Product_Attachments_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdateAttachmentByIdMutation = { __typename?: 'mutation_root', update_product_attachments_by_pk?: { __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, description?: string | null, name?: string | null } | null };


export const UpdateAttachmentByIdDocument = gql`
    mutation updateAttachmentById($set: product_attachments_set_input, $id: uuid!) {
  update_product_attachments_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    photo_link
    document_link
    video_link
    audio_link
    site_link
    transcription
    transcribed
    type
    description
    name
  }
}
    `;
export type UpdateAttachmentByIdMutationFn = Apollo.MutationFunction<UpdateAttachmentByIdMutation, UpdateAttachmentByIdMutationVariables>;

/**
 * __useUpdateAttachmentByIdMutation__
 *
 * To run a mutation, you first call `useUpdateAttachmentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttachmentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttachmentByIdMutation, { data, loading, error }] = useUpdateAttachmentByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAttachmentByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttachmentByIdMutation, UpdateAttachmentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttachmentByIdMutation, UpdateAttachmentByIdMutationVariables>(UpdateAttachmentByIdDocument, options);
      }
export type UpdateAttachmentByIdMutationHookResult = ReturnType<typeof useUpdateAttachmentByIdMutation>;
export type UpdateAttachmentByIdMutationResult = Apollo.MutationResult<UpdateAttachmentByIdMutation>;
export type UpdateAttachmentByIdMutationOptions = Apollo.BaseMutationOptions<UpdateAttachmentByIdMutation, UpdateAttachmentByIdMutationVariables>;